import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={12}
      height={16}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M6.092 0h-.377a2.857 2.857 0 00-2.858 2.857v5.086A2.857 2.857 0 005.715 10.8h.377a2.857 2.857 0 002.857-2.857V2.857A2.857 2.857 0 006.092 0z"
        fill="#333"
      />
      <Path
        d="M11.236 6.739a.57.57 0 00-.572.571 4.76 4.76 0 01-9.521 0A.571.571 0 000 7.31a5.911 5.911 0 005.332 5.875v1.672H3.427a.572.572 0 000 1.143H8.38a.571.571 0 100-1.143H6.475v-1.672a5.912 5.912 0 005.332-5.875.57.57 0 00-.572-.571z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
